import { noteSignout } from './signoutSync';

/**
 * Investigate's own sign-out, from the header menu and from the page that shows why Auth0
 * refused the sign-in (pages/Login/AuthError.js). Writes the unified sign-out note first,
 * so the other Scalens apps follow (utils/signoutSync.js), then signs out of Auth0.
 */
export async function signOut(logout) {
  try {
    await noteSignout();
  } catch (noteErr) {
    console.warn('Could not tell the other apps about the sign-out:', noteErr);
  }
  logout({ returnTo: window.location.origin });
  localStorage.removeItem('user_token');
}
